import { render } from "./OJ7040F.vue?vue&type=template&id=c2111e8a&ts=true"
import script from "./OJ7040F.vue?vue&type=script&lang=ts"
export * from "./OJ7040F.vue?vue&type=script&lang=ts"

import "./OJ7040F.vue?vue&type=style&index=0&id=c2111e8a&lang=css"

import exportComponent from "C:\\開発\\PSAP\\おくやみシステム\\OJ0000P_Vue\\OJ0000P\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__